import _objectWithoutPropertiesLoose from "../../../../@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.es.js";
import * as React from "react";
const _excluded = ["components", "componentsProps"];
function groupForwardedProps(props) {
  var _props$forwardedProps;
  const keys = Object.keys(props);
  if (!keys.some((key) => key.startsWith("aria-") || key.startsWith("data-"))) {
    return props;
  }
  const newProps = {};
  const forwardedProps = (_props$forwardedProps = props.forwardedProps) != null ? _props$forwardedProps : {};
  for (let i = 0; i < keys.length; i += 1) {
    const key = keys[i];
    if (key.startsWith("aria-") || key.startsWith("data-")) {
      forwardedProps[key] = props[key];
    } else {
      newProps[key] = props[key];
    }
  }
  newProps.forwardedProps = forwardedProps;
  return newProps;
}
function useProps(allProps) {
  return React.useMemo(() => {
    const {
      components,
      componentsProps
    } = allProps, themedProps = _objectWithoutPropertiesLoose(allProps, _excluded);
    return [components, componentsProps, groupForwardedProps(themedProps)];
  }, [allProps]);
}
export {
  useProps
};
//# sourceMappingURL=useProps.es.js.map
